export const white = '#FFF';

export const green = {
    500: '##00d1810',
};

export const red = {
    100: '#FFFDFE',
    200: '#ffc2a8',
    500: '#d16c00',
};

export const grey = {
    100: '#f7f4f2',
    200: '#f0e9e7',
    300: '#e2d6cf',
    400: '#aa9585',
    500: '#805e49',
    600: '#5b3926',
    800: '#2d1e12',
};


export const black = {
    100: 'rgba(12, 12, 14, 1)',
    200: 'rgba(167, 169, 187, 1)',
};

export const whites = {
    100: 'rgba(255, 255, 255, .6)',
    1001: 'rgba(255, 255, 255, 1)',
    200: 'rgba(167, 169, 187, 1)',
};
